import en from './en';

const ar = {
  ...en,
  lang: 'ar',
  langName: 'العربية',
  flag: '🇸🇦',
  siteTitle: 'اختبارات TOEFL iBT مجانية - تحليل بالذكاء الاصطناعي | Power TOEFL 2026',
  siteDescription: 'تدرّب على أحدث اختبارات TOEFL لعام 2026 مجانًا مع تحليل القراءة والاستماع والتحدث والكتابة ومراجعة الأخطاء وتحويل الدرجات.',
  ogTitle: 'اختبارات TOEFL iBT مجانية - تحليل بالذكاء الاصطناعي | Power TOEFL 2026',

  navGrammar: 'القواعد',
  navPractice: 'تدريب الأقسام',
  navScoreChart: 'جدول الدرجات',
  navVocabulary: 'المفردات',
  navTips: 'النصائح والاستراتيجية',
  navFAQ: 'الأسئلة الشائعة',
  navReading: 'القراءة',
  navListening: 'الاستماع',
  navSpeaking: 'التحدث',
  navWriting: 'الكتابة',
  navQuestionPool: 'بنك الأسئلة',
  navResources: 'الموارد',
  navPremium: 'الخطة المميزة',

  loginButton: 'تسجيل الدخول',
  wrongAnswers: 'مفكرة الأخطاء',
  logout: 'تسجيل الخروج',
  loginRequired: 'يلزم تسجيل الدخول لاستخدام مفكرة الأخطاء واستكمال الاختبار.',

  heroBadge: 'منصة TOEFL المميزة',
  heroTitle1: 'منصة واحدة',
  heroTitle2: 'لرفع درجتك في TOEFL',
  heroDesc1: 'من اختبارات المحاكاة الكاملة إلى مراجعة الأخطاء الشخصية،',
  heroDesc2: 'كل ما تحتاجه للوصول إلى هدفك في مكان واحد.',

  moreTools: 'أدوات تعلم إضافية',
  practiceLabel: 'تدريب حسب القسم',
  practiceDesc: 'تدرّب على القراءة والاستماع بشكل منفصل',
  scoreChartLabel: 'تحويل الدرجات',
  scoreChartDesc: 'من الإجابات الصحيحة إلى الدرجة المتوقعة',
  vocabLabel: 'المفردات',
  vocabDesc: 'أهم مفردات TOEFL',
  tipsLabel: 'النصائح والاستراتيجية',
  tipsDesc: 'خطة القراءة والاستماع',
  catLabel: 'اختبار CAT التكيفي',
  catDesc: 'تتغير الصعوبة تلقائيًا حسب مستواك',
  guideLabel: 'أدلة الدراسة',
  guideDesc: 'استراتيجيات حسب المهارة وخطط حسب الدرجة',
  grammarSectionTitle: 'كتاب القواعد الإنجليزية',
  grammarSectionDesc: 'ابنِ أساس القواعد خطوة بخطوة',
  grammarViewAll: 'عرض الكل',
  proBadgeLabel: 'برو',

  footerMockTest: 'التدريب',
  footerQuestionPool: 'بنك الأسئلة',
  footerPractice: 'تدريب الأقسام',
  footerStudy: 'الدراسة',
  footerBooks: 'كتب مقترحة',
  footerEtc: 'المزيد',
  footerLC: 'تدريب الاستماع',
  footerRC: 'تدريب القراءة',
  footerSpeaking: 'تدريب التحدث',
  footerWriting: 'تدريب الكتابة',
  footerLCStrategy: 'استراتيجية الاستماع',
  footerRCStrategy: 'استراتيجية القراءة',
  footerGuide: 'دليل الدراسة',
  footerPrivacy: 'سياسة الخصوصية',
  footerTerms: 'الشروط',
  footerRefund: 'سياسة الاسترداد',
  footerAbout: 'حول الخدمة',
  footerCopyright: '© 2026 Power TOEFL. جميع الحقوق محفوظة.',
  footerDisclaimer: 'TOEFL® علامة تجارية مسجلة لدى ETS. Power TOEFL منصة مستقلة وغير تابعة لـ ETS.',

  fullTestCardLabel: 'اختبار كامل',
  fullTestCardDesc: 'محاكاة واقعية للقراءة والاستماع',
  googleLogin: 'ابدأ باستخدام Google',

  pwaAddToHome: 'أضف إلى الشاشة الرئيسية',
  pwaAddToHomeDesc: 'افتح Power TOEFL بسرعة أكبر مثل التطبيق.',
  pwaInstall: 'تثبيت',
  pwaIOSGuide: 'مشاركة',

  resumeTest: 'متابعة',
  resumeDesc: '{0} الجولة {1} — {2}/{3} سؤالاً',
  progressLabel: 'التقدم',
  timerLabel: 'الوقت المتبقي',
  timeUp: 'انتهى الوقت!',
  navHome: 'الرئيسية',
  navSettings: 'النصائح',

  speakingPageH1: 'تدريب TOEFL Speaking',
  speakingPageDesc: 'تدرّب على جميع مهام Speaking مع التسجيل وتغذية راجعة بالذكاء الاصطناعي.',
  writingPageH1: 'تدريب TOEFL Writing',
  writingPageDesc: 'تدرّب على Build a Sentence وEmail وAcademic Discussion.',
  grammarBookTitle: 'قواعد TOEFL',
  grammarCourseName: 'قواعد اللغة الإنجليزية لـ TOEFL',
  grammarBreadcrumb: 'القواعد',

  statsTitle: 'إحصاءات الدراسة | Power TOEFL',
  statsDesc: 'راجع تقدمك ونقاط ضعفك ونشاطك الأسبوعي.',
  statsH1: 'إحصاءاتي',
  statsLoginPrompt: 'سجّل الدخول لعرض إحصاءاتك الشخصية.',
  statsLast7Days: 'آخر 7 أيام',
  statsTotalWrong: 'إجمالي الأخطاء',

  leaderboardTitle: 'لوحة الصدارة الدراسية',
  leaderboardWeekly: 'أسبوعي',
  leaderboardMonthly: 'شهري',
  leaderboardLoading: 'جارٍ التحميل...',
  leaderboardEmpty: 'لا توجد بيانات لهذا {period} بعد.',
  leaderboardEmptyWeek: 'الأسبوع',
  leaderboardEmptyMonth: 'الشهر',
  leaderboardHint: 'أكمل الاختبارات ليتم إدراجك تلقائيًا في الترتيب.',
  leaderboardRank: 'الترتيب',
  leaderboardNickname: 'الاسم',
  leaderboardSolved: 'المحلول',
  leaderboardAccuracy: 'الدقة',
  leaderboardMe: 'أنا',

  pricingTitle: 'خطط Power TOEFL Pro — ر.س49/شهر | المجاني مقابل Premium | 2026',
  pricingDesc: 'قارن بين الخطة المجانية وPro: تدريب غير محدود، تحليل بالذكاء الاصطناعي، شروحات مفصلة، وتجهيز أكثر كفاءة لاختبار TOEFL.',
  pricingLoginRequired: 'يرجى تسجيل الدخول للمتابعة.',
  pricingPaymentError: 'حدث خطأ أثناء الدفع.',
  pricingPaymentCancelled: 'تم إلغاء عملية الدفع.',
  pricingFaqQ1: 'ما الفرق بين Free وPro؟',
  pricingFaqA1: 'يوفر Pro أسئلة غير محدودة وشروحات مفصلة وتحليلاً بالذكاء الاصطناعي.',
  pricingFaqQ2: 'هل يمكنني طلب استرداد؟',
  pricingFaqA2: 'نظرًا لطبيعة المنتجات الرقمية، لا يتوفر الاسترداد بشكل عام. ومع ذلك، قد يتم قبول الاسترداد استثنائيًا إذا كان مطلوبًا قانونًا، أو في حال الدفع المكرر، أو عدم تقديم الخدمة، أو حدوث عطل تقني جسيم.',
  pricingFaqQ3: 'كيف ألغي الاشتراك؟',
  pricingFaqA3: 'يمكنك إدارة الاشتراك أو إلغاؤه من خلال منصة الدفع.',
  pricingFaqQ4: 'ما الفرق بين الخطة السنوية وLifetime؟',
  pricingFaqA4: 'الخطة السنوية تتجدد كل سنة، أما Lifetime فهو شراء لمرة واحدة عند توفره.',

  aboutCtaHeading: 'ابدأ الآن',
  aboutCtaDesc: 'جرّب اختبار TOEFL تجريبي مجاني الآن.',
  aboutCtaStart: 'ابدأ مجانًا',
  aboutCtaPricing: 'عرض Premium',

  // --- Auto-translated UI strings ---
  lcTitle: "الاستماع",
  lcSubtitle: "الاستماع - 28 سؤالاً",
  lcTime: "36 دقيقة",
  rcTitle: "القراءة",
  rcSubtitle: "القراءة - 20 سؤالاً",
  rcTime: "35 دقيقة",
  startTest: "ابدأ الاختبار",
  fullTestStart: "ابدأ الاختبار التجريبي الكامل (القراءة -> الاستماع)",
  fullTestDesc: "أكمل القسمين بالتتابع",
  part1: "القراءة الأكاديمية (20)",
  part2: "محادثات (10)",
  part3: "محاضرات (18)",
  statQuestions: "الأسئلة",
  statParts: "الأجزاء",
  statMinutes: "الدقائق",
  faqTitle: "الأسئلة المتكررة",
  faqDesc: "اعثر على إجابات حول TOEFL وPower TOEFL.",
  faqPageTitle: "تسجيل TOEFL، النتيجة، الصلاحية - أسئلة متكررة 2026 | Power TOEFL",
  faqPageDesc: "التسجيل، تحويل الدرجات، الصلاحية، واستراتيجية الأقسام في صفحة واحدة.",
  faqMore: "هل تحتاج إلى مزيد من المساعدة؟ نحن نواصل تحديث هذا القسم من الأسئلة المتكررة.",
  scoreChartPageTitle: "تحويل درجات TOEFL 2026 - تحقق من درجات الأقسام على الفور | Power TOEFL",
  scoreChartPageDesc: "تحويل درجات أقسام TOEFL للقراءة، الاستماع، التحدث، الكتابة. أدخل الإجابات الصحيحة للدرجة المقدرة والإرشاد المستهدف.",
  scoreChartHeading: "جدول تحويل درجات TOEFL",
  scoreChartIntro: "جداول 0–30 للأقسام و0–120 للمجموع هي تقديرات دراسية من Power TOEFL على المقياس القديم/القابل للمقارنة. تعرض تقارير 2026 الرسمية أولاً درجات الأقسام والدرجة الكلية من 1–6 بأنصاف النقاط.",
  scoreChartLC: "تحويل القراءة",
  scoreChartRC: "تحويل الاستماع",
  scoreChartCorrect: "صحيح",
  scoreChartConverted: "الدرجة المحولة",
  scoreChartUnit: "",
  scoreChartPointUnit: "نقطة",
  scoreGuideTitle: "دليل النتيجة المستهدفة",
  scoreGuide900: "الفئة العليا",
  scoreGuide900Desc: "استهدف 28+ لكل قسم. قوي للقبول في أفضل الجامعات.",
  scoreGuide800: "الفئة فوق المتوسطة",
  scoreGuide800Desc: "استهدف 22+ لكل قسم. يفي بمعظم متطلبات القبول.",
  scoreGuide700: "فوق المتوسط",
  scoreGuide700Desc: "تم تحقيق الأساس الأكاديمي. القبول المشروط ممكن.",
  scoreGuide600: "متوسط",
  scoreGuide600Desc: "ركز على أساسيات القراءة والاستماع أولاً.",
  scoreChartFaqTitle: "الأسئلة الشائعة حول نتيجة التوفل",
  scoreChartCtaTitle: "تحقق من مستواك الآن",
  scoreChartCtaDesc: "خُضْ اختبار توفل تجريبي مجاني وقدّر نتيجتك.",
  scoreReadingHeader: "القراءة (0-30 نقطة)",
  scoreListeningHeader: "الاستماع (0-30 نقطة)",
  scoreSpeakingHeader: "المحادثة (0-30 نقطة)",
  scoreWritingHeader: "الكتابة (0-30 نقطة)",
  scoreSpeakingDesc: "يتم تقييم 4 مهام على مقياس 0-4، ثم تحويلها إلى 30 نقطة",
  scoreWritingDesc: "يتم تقييم مهمتين على مقياس 0-5، ثم تحويلهما إلى 30 نقطة",
  vocabPageTitle: "600 كلمة توفل عالية التردد - المعاني والأمثلة | Power TOEFL",
  vocabPageDesc: "تعلم 600 كلمة توفل حسب الفئة مع معانٍ وأمثلة فورية.",
  vocabHeading: "المفردات الأساسية للتوفل",
  vocabIntro: "ادرس المفردات الضرورية حسب الفئة. انقر للكشف عن المعاني.",
  vocabShowAll: "إظهار الكل",
  vocabHideAll: "إخفاء الكل",
  vocabReset: "إعادة تعيين",
  vocabClickToReveal: "انقر للكشف عن المعنى",
  vocabMotivation: "التكرار المستمر يرفع نتيجتك في التوفل.",
  vocabMyWords: "مفرداتي",
  vocabAddWord: "إضافة كلمة",
  vocabAddWordPlaceholder: "أدخل كلمة إنجليزية",
  vocabMyWordsEmpty: "لم تتم إضافة أي كلمات بعد. أضف كلمتك الأولى أعلاه.",
  vocabDeleteWord: "حذف",
  vocabLookingUp: "جارٍ البحث...",
  vocabQuizTitle: "اختبار المفردات",
  vocabQuizDesc: "اختبر المرادفات والمتضادات للكلمات التي تعلمتها.",
  vocabQuizMode_synonym: "اختبار المرادفات",
  vocabQuizMode_antonym: "اختبار المتضادات",
  vocabQuizMode_mixed: "اختبار مختلط",
  vocabQuizClose: "إغلاق",
  vocabQuizNoQuestions: "لا توجد عناصر كافية للاختبار في هذه الفئة بعد.",
  vocabQuizBack: "رجوع",
  vocabQuizResult: "نتائج الاختبار",
  vocabQuizExcellent: "ممتاز!",
  vocabQuizGood: "عمل رائع. المزيد من الممارسة وأنت جاهز.",
  vocabQuizKeepGoing: "استمر!",
  vocabQuizRetry: "إعادة المحاولة",
  vocabQuizFindSynonym: "اختر المرادف للكلمة التالية",
  vocabQuizFindAntonym: "اختر المتضاد للكلمة التالية",
  vocabQuizNext: "التالي",
  vocabQuizFinish: "عرض النتيجة",
  vocabQuizStart: "بدء الاختبار",
  vocabCatNaturalScience: "العلوم الطبيعية",
  vocabCatSocialScience: "العلوم الاجتماعية",
  vocabCatHumanities: "العلوم الإنسانية",
  vocabCatLifeScience: "علوم الحياة",
  vocabCatTechnology: "التكنولوجيا/الهندسة",
  vocabCatAcademicGeneral: "أكاديمي عام",
  tipsLCPageTitle: "كيف ترفع درجة الاستماع في التوفل | روتين تدريب الاستماع - Power TOEFL",
  tipsLCPageDesc: "تدريب عملي على الاستماع في التوفل لتحقيق درجات أعلى: تدوين الملاحظات للمحادثات والمحاضرات، الاستدلال، وأسئلة موقف المتحدث.",
  tipsLCHeading: "استراتيجية درجة الاستماع في التوفل",
  tipsLCIntro: "استراتيجيات أساسية وروتين عملي لكل جزء من اختبار الاستماع في التوفل.",
  tipsLCPractice: "تدرب على الاستماع الآن",
  tipsLCPracticeDesc: "طبق الاستراتيجية باختبار تدريبي حقيقي.",
  tipsLCStartTest: "ابدأ اختبار الاستماع",
  tipsRCPageTitle: "استراتيجية قراءة التوفل - دليل المقاطع الأكاديمية | Power TOEFL",
  tipsRCPageDesc: "استراتيجية قراءة التوفل للمقاطع الأكاديمية: تخصيص الوقت، الاستنتاج، ومنهجية الأسئلة الملخصة.",
  tipsRCHeading: "استراتيجية قراءة التوفل",
  tipsRCIntro: "دليل عملي لاستراتيجية وتوقيت مقاطع القراءة في التوفل.",
  tipsRCPractice: "تدرب على القراءة الآن",
  tipsRCPracticeDesc: "طبق الاستراتيجية باختبار تدريبي حقيقي.",
  tipsRCStartTest: "ابدأ اختبار القراءة",
  tips7DayTitle: "خطة دراسة اللحظة الأخيرة لمدة 7 أيام",
  tips7DayDesc: "حقق أقصى درجة بروتين أسبوع أخير مركز",
  tipsTrapTitle: "دليل أنماط الفخاخ",
  tipsTrapDesc: "تعرف على الأنماط الخمسة الأكثر شيوعًا للفخاخ مقدمًا",
  aboutPageTitle: "عن Power TOEFL - اختبارات تجريبية مجانية للتوفل وأدوات دراسة بالذكاء الاصطناعي",
  aboutPageDesc: "تدرب على التوفل باختبارات تجريبية كاملة، وتحليل نقاط الضعف بالذكاء الاصطناعي، ومراجعة تلقائية للإجابات الخاطئة. اكتشف ما يقدمه Power TOEFL.",
  aboutHeading: "Power TOEFL - منصة عملية للتحضير لاختبار التوفل",
  aboutS1Title: "ما هو Power TOEFL؟",
  aboutS1Body: "Power TOEFL هي منصة مجانية عبر الإنترنت للمتعلمين الذين يستعدون لاختبار التوفل. نحن نوفر اختبارات تجريبية كاملة، وتدريبًا مولدًا بالذكاء الاصطناعي، وأدوات مراجعة الإجابات الخاطئة.",
  aboutS2Title: "لمن هذه المنصة؟",
  aboutS2Body: "موصى به للطلاب الذين يستعدون لاختبار التوفل للقبول، والمهنيين الذين يستهدفون درجات معينة، والمتعلمين المستقلين الذين يرغبون في تدريب منظم.",
  aboutS3Title: "الميزات الرئيسية",
  aboutFeature1: "اختبارات تجريبية كاملة على غرار التوفل مع جولات متعددة",
  aboutFeature2: "تدريب مركز على الأقسام للقراءة، الاستماع، المحادثة، والكتابة",
  aboutFeature3: "توليد أسئلة وتحليل نقاط الضعف مدعوم بالذكاء الاصطناعي",
  aboutFeature4: "دفتر ملاحظات تلقائي للإجابات الخاطئة مع مراجعة متباعدة",
  aboutFeature5: "جدول تحويل الدرجات ومفردات التوفل الأساسية",
  aboutS4Title: "مجاني مقابل مميز",
  aboutS4Body: "الخطة المجانية تتضمن اختبارات تجريبية، تدريب على الأقسام، وتحويل الدرجات. الخطة المميزة تضيف توليدًا غير محدود بالذكاء الاصطناعي، دراسة بدون إعلانات، ووصولًا كاملًا للاختبارات التجريبية.",
  aboutS5Title: "لماذا تتحسن الدرجات",
  aboutS5Body: "مع التكرار المتباعد، والتحليل المستهدف لنقاط الضعف، وظروف التدريب الواقعية، يمكن للمتعلمين بناء أداء اختبار مستقر بمرور الوقت.",
  aboutS6Title: "العلاقة مع ETS",
  aboutS6Body: "Power TOEFL هي منصة تعليمية مستقلة وغير تابعة لـ ETS أو معتمدة منها. TOEFL هي علامة تجارية مسجلة لـ ETS.",
  aboutS7Title: "تواصل معنا",
  aboutS7Body: "للاستفسارات المتعلقة بالخدمة، يرجى التواصل عبر skdaks0731@gmail.com.",
  catPageTitle: "اختبار TOEFL التكيفي (CAT) - صعوبة تلقائية بواسطة الذكاء الاصطناعي | Power TOEFL",
  catPageDesc: "اختبار TOEFL تدريبي تكيفي عبر الكمبيوتر. يقوم الذكاء الاصطناعي تلقائيًا بتعديل صعوبة الأسئلة بناءً على أدائك.",
  catHeading: "الاختبار التكيفي (CAT)",
  catIntro: "تتعدل الصعوبة تلقائيًا حسب دقتك. {count} أسئلة في كل جلسة.",
  catNote: "ℹ️ ملاحظة: اختبار TOEFL iBT الحقيقي هو اختبار خطي (غير تكيّفي). هذا الـ Practice CAT أداة دراسية تعدّل الصعوبة حسب أدائك لتحدد مستواك بسرعة، وهو ليس محاكاة لصيغة الاختبار الحقيقية.",
  catSelectSection: "اختر القسم",
  catStartBtn: "ابدأ الاختبار التكيفي",
  catLoading: "جارٍ تحميل السؤال التالي...",
  catNoMore: "لا توجد أسئلة أخرى متاحة",
  catComplete: "اكتمل الاختبار التكيفي",
  catAccuracy: "الدقة",
  catFinalLevel: "الصعوبة النهائية",
  catTryAgain: "حاول مرة أخرى",
  catViewResults: "عرض النتائج",
  catNext: "التالي",
  catExplanation: "الشرح",
  catStop: "إيقاف",
  catPlayAudio: "تشغيل الصوت",
  catReadingPassage: "قطعة القراءة",
  pricingSaveBadge: "خصم 30%",
  pricingPerMonth: "شهريا",
  pricingSSL: "دفع آمن",
  pricingCard: "الدفع بالبطاقة",
  pricingPaymentSuccess: "تم تفعيل الاشتراك المميز بنجاح!",
  pricingCurrentPlan: "الخطة الحالية",
  grammarSystematic: "تعلّم منهجي لقواعد اللغة",
  grammarBookDesc: "تعلم 20 موضوعًا أساسيًا من قواعد اللغة الخاصة باختبار التوفل مع أمثلة وتمارين عملية.",
  grammarTestAfter: "اختبر معلوماتك مباشرة بعد الدراسة!",
  grammarTestAfterDesc: "تحقق من كيفية ظهور النقاط النحوية في أسئلة التوفل الحقيقية.",
  grammarMockTest: "الاختبار التجريبي",
  grammarDoneTitle: "هل انتهيت من دراسة القواعد؟",
  grammarDoneDesc: "طبّق ما تعلمته في اختبار تجريبي. يتم حفظ الإجابات الخاطئة تلقائيًا للمراجعة.",
  grammarStartRC: "ابدأ اختبار القراءة التجريبي",
  grammarPracticePart5: "ممارسة قواعد جزء القراءة",
  leaderboardMyRank: "🏅 ترتيبي: #{rank}",
  speakingPageSub: "{count}+ أسئلة مجانية لممارسة التحدث — Listen and Repeat · Interview",
  speakingPageTitle: "ممارسة التحدث في امتحان التوفل 2026 - {count}+ أسئلة مجانية وإجابات نموذجية | Power TOEFL",
  speakingAllTasks: "الكل",
  speakingNoPrompts: "لا توجد أسئلة تحدث بعد",
  speakingNoPromptsSub: "يتم إنشاء الأسئلة. يرجى التحقق مرة أخرى قريبًا.",
  speakingResponseTime: "وقت الاستجابة",
  writingPageSub: "{count}+ مهام كتابية مجانية — Build a Sentence · Email · Academic Discussion",
  writingPageTitle: "ممارسة الكتابة في امتحان التوفل 2026 - {count}+ مهام مجانية | Power TOEFL",
  writingAllTasks: "الكل",
  writingNoPrompts: "لا توجد مهام كتابية بعد",
  writingNoPromptsSub: "يتم إنشاء المهام. يرجى التحقق مرة أخرى قريبًا.",
  testPrevious: "السابق",
  testNext: "التالي",
  testQuestion: "سؤال",
  testQuestionPrompt: "اقرأ السؤال واختر أفضل إجابة.",
  testMarkAnswer: "يرجى تحديد رقم أفضل إجابة.",
  testSelect: "اختر",
  testShowAnswer: "إظهار الإجابة والشرح",
  testCorrect: "صحيح!",
  testIncorrect: "غير صحيح.",
  testSubmit: "إرسال الاختبار",
  testContinue: "متابعة",
  resultsTitle: "نتيجة اختبار {0}",
  resultsTimeUsed: "الوقت المستخدم: {0}د و {1} ث",
  resultsEstimatedScore: "الدرجة المقدرة (من 30)",
  resultsCorrect: "صحيح",
  resultsIncorrect: "غير صحيح",
  vocabSynonyms: "مرادفات",
  vocabAntonyms: "متضادات",
  tipsLCButton: "استراتيجية الاستماع",
  tipsRCButton: "استراتيجية القراءة",
  practiceRelatedLinks: "📌 محتوى دراسي ذو صلة",
  practiceOtherParts: "أقسام أخرى",
  practiceMockTestCTA: "تدرب باختبار تجريبي كامل",
  practiceTipsLink: "عرض استراتيجيات خاصة بالقسم",
  practiceGrammarLink: "دراسة القواعد",
  practiceNotFound: "القسم غير موجود.",
  practiceQuestionType: "نوع السؤال",
  practiceTips: "💡 نصائح استراتيجية",
  practiceExamples: "📝 أسئلة أمثلة",
  practiceIntro: "📋 نظرة عامة على القسم",
  practiceCommonTypes: "📊 أنواع الأسئلة الشائعة",
  practiceStrategy: "🎯 الاستراتيجيات الرئيسية",
  practiceRecommendedFor: "👤 موصى به لـ",
  practiceFAQ: "❓ الأسئلة الشائعة",
  practiceCTA: "تدرب الآن",
  practiceCTADesc: "يمكنك التدرب على القسم {0} في بيئة اختبار واقعية.",
  practiceStartTest: "ابدأ الاختبار التجريبي {0}",
  practiceQuestions: "الأسئلة",
  practicePartSelect: "اختر القسم",
  roundsTitle: "جولات الاختبار التجريبي",
  roundLabel: "الاختبار التجريبي للـ TOEFL",
  roundUnit: "جولة",
  comingSoon: "قريبًا",
  testLoginPrompt: "ملاحظات الإجابات الخاطئة وميزات الاستئناف تتطلب تسجيل الدخول.",
  testGoogleLogin: "ابدأ باستخدام جوجل خلال 3 ثوانٍ",
  roundSelect: "اختر جولة أخرى",
  testAnswered: "تمت الإجابة",
  testSubmitTitle: "إرسال اختبار {0}؟",
  testSubmitDesc: "لقد أجبت على {1} من أصل {0} أسئلة.",
  testUnanswered: "{0} أسئلة لم يتم الإجابة عليها.",
  testCannotUndo: "لا يمكن التراجع عن هذا الإجراء.",
  testSubmitBtn: "إرسال",
  resultsAccuracy: "الدقة",
  resultsReview: "مراجعة الإجابات",
  resultsYourAnswer: "إجابتك: {0}",
  resultsCorrectAnswer: "الإجابة الصحيحة: {0}",
  resultsNoAnswer: "لا توجد إجابة",
  resultsHome: "الرئيسية",
  resultsWrongNotes: "الإجابات الخاطئة",
  resultsRetry: "إعادة المحاولة",
  resultsShare: "مشاركة النتائج",
  resultsShareText: "درجة الـ TOEFL التقديرية الخاصة بي هي {0} {1}! ({2}/{3} صحيحة، {4}% دقة) اختبر مهاراتك مجانًا مع Power TOEFL!",
  resultsShareCopied: "تم نسخ النتائج إلى الحافظة!",
  resultsNoResults: "لا توجد نتائج للاختبار.",
  resultsGoHome: "اذهب للمنزل",
  resultsSaved: "تم حفظ {0} إجابة خاطئة في إجاباتك الخاطئة",
  wrongAnswersTitle: "الإجابات الخاطئة",
  wrongAnswersSaved: "العناصر المحفوظة",
  wrongAnswersHome: "الرئيسية",
  wrongAnswersPracticeAll: "تدرب على الكل",
  wrongAnswersAll: "الكل",
  wrongAnswersNoItems: "لا توجد إجابات خاطئة حتى الآن. قم بإجراء اختبار أولاً!",
  wrongAnswersYourAnswer: "إجابتك: {0}",
  wrongAnswersCorrectIs: "الإجابة الصحيحة: {0}",
  wrongAnswersReviewed: "تمت المراجعة",
  wrongAnswersRemoved: "تمت الإزالة من الإجابات الخاطئة",
  wrongAnswersPracticeMode: "وضع التدريب",
  wrongAnswersCorrectMsg: "صحيح!",
  wrongAnswersIncorrectMsg: "غير صحيح. الإجابة الصحيحة: {0}",
  wrongAnswersNextQuestion: "السؤال التالي",
  wrongAnswersFinish: "إنهاء التدريب",
  wrongAnswersExitPractice: "الخروج من التدريب",
  wrongAnswersPracticeComplete: "اكتمل التدريب!",
  wrongAnswersNoPractice: "لا توجد إجابات خاطئة للتدرب عليها",
  wrongAnswersLimitNotice: "يتم عرض أحدث 500 إجابة خاطئة فقط.",
  privacyPageTitle: "سياسة الخصوصية — Power TOEFL",
  privacyPageDesc: "سياسة خصوصية Power TOEFL.",
  privacyHeading: "سياسة الخصوصية",
  privacyLastUpdated: "آخر تحديث: 29 مارس 2026",
  privacyS1Title: "1. المعلومات الشخصية التي يتم جمعها",
  privacyS1Body: "يجمع Power TOEFL عنوان بريدك الإلكتروني واسمك وصورة ملفك الشخصي عند تسجيل الدخول باستخدام Google لتقديم الخدمة. عند إجراء الدفعات، تتم معالجة معلومات الدفع عبر مزودي خدمة الدفع (Dodo Payments/PayPal)؛ نحن لا نخزن تفاصيل بطاقة الدفع مباشرة.",
  privacyS2Title: "2. الغرض من الاستخدام",
  privacyS2Body: "تُستخدم البيانات الشخصية التي يتم جمعها فقط لحفظ الإجابات الخاطئة وتتبع التقدم الدراسي وإدارة الاشتراكات ودعم العملاء وتحسين الخدمة.",
  privacyS3Title: "3. الاحتفاظ بالبيانات وحذفها",
  privacyS3Body: "عندما يقوم المستخدم بحذف حسابه، تُحذف البيانات الشخصية على الفور. تُحتفظ بسجلات الدفع لمدة تصل إلى 5 سنوات حسب متطلبات قانون الضرائب ثم تُحذف. إذا كانت هناك قوانين أخرى تتطلب الاحتفاظ، فستُحفظ البيانات للفترة المطلوبة ثم تُحذف.",
  privacyS4Title: "4. الكشف عن الطرف الثالث",
  privacyS4Body: "لمعالجة الدفعات، نشارك الحد الأدنى من المعلومات المطلوبة (البريد الإلكتروني) مع Dodo Payments (التاجر المسجل) أو PayPal. نحن لا نقدم البيانات الشخصية للمستخدمين لأي طرف ثالث آخر إلا إذا كان ذلك مطلوبًا بموجب القانون.",
  privacyS5Title: "5. ملفات تعريف الارتباط والإعلانات",
  privacyS5Body: "يعرض هذا الموقع إعلانات عبر Google AdSense ويستخدم ملفات تعريف الارتباط لهذا الغرض. يمكن إدارة ملفات تعريف الارتباط في إعدادات متصفحك. للحصول على تفاصيل حول ملفات تعريف الارتباط الإعلانية من Google، راجع سياسة خصوصية Google.",
  privacyS6Title: "6. عمليات نقل البيانات الدولية",
  privacyS6Body: "تستخدم هذه الخدمة خوادم تقع في الخارج، وقد يتم نقل البيانات دوليًا لمعالجة المدفوعات. نحن نحمي البيانات الشخصية بتدابير أمنية مناسبة.",
  privacyS7Title: "7. حقوق المستخدم",
  privacyS7Body: "يجوز للمستخدمين طلب الوصول إلى بياناتهم الشخصية أو تصحيحها أو حذفها في أي وقت. يتمتع المقيمون في الاتحاد الأوروبي/المنطقة الاقتصادية الأوروبية بحقوق إضافية بموجب اللائحة العامة لحماية البيانات (GDPR). لحذف حسابك، يرجى تسجيل الخروج والاتصال بنا.",
  privacyS8Title: "8. الاتصال",
  privacyS8Body: "للاستفسارات المتعلقة بالخصوصية، يرجى الاتصال بـ skdaks0731@gmail.com.",
  termsPageTitle: "شروط الخدمة — Power TOEFL",
  termsPageDesc: "شروط خدمة Power TOEFL.",
  termsHeading: "شروط الخدمة",
  termsLastUpdated: "آخر تحديث: 29 مارس 2026",
  termsS1Title: "1. نظرة عامة على الخدمة",
  termsS1Body: "Power TOEFL هي منصة تعليمية عبر الإنترنت للتحضير لاختبار TOEFL، وتُدار بواسطة ddookddak (اسم عملنا القانوني المسجل). نحن نقدم ميزات مجانية واشتراكات مدفوعة مميزة (Pro/Lifetime) تتضمن اختبارات تدريبية وممارسة خاصة بالأقسام وتوليد أسئلة بالذكاء الاصطناعي وملاحظات للإجابات الخاطئة.",
  termsS2Title: "2. الأهلية",
  termsS2Body: "الخدمة متاحة للمستخدمين الذين تبلغ أعمارهم 14 عامًا فما فوق. تتطلب بعض الميزات (ملاحظات الإجابات الخاطئة، وممارسة الذكاء الاصطناعي، وما إلى ذلك) تسجيل الدخول بحساب Google، وتتطلب الميزات المميزة اشتراكًا مدفوعًا.",
  termsS3Title: "3. الملكية الفكرية",
  termsS3Body: "المحتوى الموجود في هذا الموقع (الأسئلة، التصميم، الكود، إلخ) مملوك لـ Power TOEFL. TOEFL هي علامة تجارية مسجلة لـ ETS؛ هذا الموقع غير تابع لـ ETS.",
  termsS4Title: "4. الخدمات المدفوعة والدفع",
  termsS4Body: "تتم معالجة الاشتراكات المميزة عبر خدمات دفع طرف ثالث (Dodo Payments/PayPal). يتم تحصيل رسوم الاشتراك تلقائيًا أو كدفعة لمرة واحدة حسب الخطة المختارة (شهري/سنوي/مدى الحياة). قد تشمل الأسعار ضريبة القيمة المضافة؛ يظهر المبلغ النهائي عند السداد. راجع سياسة الاسترداد المنفصلة للحصول على تفاصيل الاسترداد.",
  termsS5Title: "5. إخلاء المسؤولية",
  termsS5Body: "نتائج الاختبارات التجريبية والمواد الدراسية التي تقدمها هذه الخدمة هي لأغراض مرجعية فقط ولا تضمن نتائج TOEFL الفعلية. نحن لسنا مسؤولين عن الأضرار المباشرة أو غير المباشرة الناتجة عن استخدام الخدمة.",
  termsS6Title: "6. السلوك المحظور",
  termsS6Body: "لا يجوز لك نسخ أو توزيع الأسئلة دون إذن، أو إرهاق النظام، أو مشاركة الحسابات مع الآخرين، أو الانخراط في أنشطة غير قانونية أخرى.",
  termsS7Title: "7. تغييرات الخدمة والتعليق",
  termsS7Body: "قد يقوم المشغل بتغيير أو تعليق الخدمة دون إشعار مسبق ولا يلزم بتقديم تعويض.",
  termsS8Title: "8. إلغاء الاشتراك",
  termsS8Body: "يمكن إلغاء الاشتراكات المدفوعة في أي وقت. بعد الإلغاء، تظل الميزات المميزة متاحة حتى نهاية الفترة المدفوعة، وبعد ذلك سيعود الحساب إلى الخطة المجانية.",
  termsS9Title: "9. تغييرات على الشروط",
  termsS9Body: "قد يتم تحديث هذه الشروط حسب الحاجة؛ سيتم نشر التغييرات على الموقع. يشكل الاستخدام المستمر للخدمة بعد التغييرات قبولًا للشروط المحدثة.",
  refundPageTitle: "سياسة الاسترداد — Power TOEFL",
  refundPageDesc: "سياسة استرداد اشتراك Power TOEFL المميز.",
  refundHeading: "سياسة الاسترداد",
  refundLastUpdated: "آخر تحديث: 15 أبريل 2026",
  refundS1Title: "1. مبدأ الاسترداد",
  refundS1Body: "نظرًا لطبيعة المنتجات الرقمية، لا يتوفر الاسترداد بشكل عام.",
  refundS2Title: "2. حالات الاسترداد الاستثنائية",
  refundS2Body: "قد يتم قبول الاسترداد استثنائيًا إذا كان مطلوبًا قانونًا، أو في حال الدفع المكرر، أو عدم تقديم الخدمة، أو حدوث عطل تقني جسيم.",
  refundS3Title: "3. طريقة التواصل",
  refundS3Body: "لاستفسارات الاسترداد، يرجى استخدام قناة الدعم/الملاحظات. التواصل: skdaks0731@gmail.com",
  refundS4Title: "4. إلغاء الاشتراك",
  refundS4Body: "يمكن إلغاء الاشتراكات المدفوعة في أي وقت. بعد الإلغاء، يستمر الوصول المميز حتى نهاية فترة الفوترة الحالية، ولن يتم فرض رسوم إضافية بعد ذلك.",
  refundS5Title: "",
  refundS5Body: "",
  refundS6Title: "",
  refundS6Body: "",
  grammarChapter: "الفصل",
  aiPracticeTitle: "إنشاء أسئلة TOEFL غير محدودة بالذكاء الاصطناعي - اختر الجزء والصعوبة للحصول على أسئلة فورية | Power TOEFL",
  aiPracticeDesc: "اختر جزءًا ومستوى صعوبة وسيُنشئ الذكاء الاصطناعي أسئلة TOEFL على الفور. أسئلة تدريب مجانية مع شروحات تلقائية - احصل على أسئلة جديدة كل يوم.",
  aiPracticeH1: "✨ مولد أسئلة TOEFL بالذكاء الاصطناعي",
  aiPracticeSub: "ينشئ الذكاء الاصطناعي أسئلة TOEFL في الوقت الفعلي بالصعوبة التي تختارها.",
  aiPartLabel: "الجزء",
  aiDiffLabel: "الصعوبة",
  aiBeginner: "مبتدئ (1.0–2.5)",
  aiIntermediate: "متوسط (3.0–4.5)",
  aiAdvanced: "متقدم (5.0–6.0)",
  aiGenerate: "إنشاء أسئلة",
  aiGenerating: "جارٍ الإنشاء...",
  aiRemainingToday: "تبقى {0} هذا الشهر",
  aiLimitReached: "لقد استخدمت جميع أرصدة الذكاء الاصطناعي لهذا الشهر",
  aiLimitUpgrade: "اشترِ المزيد من الأرصدة أو قم بترقية خطتك!",
  aiUpgrade: "ترقية",
  aiListenPrompt: "🔊 لأسئلة الاستماع، استمع إلى الصوت أثناء الإجابة",
  aiPlayAudio: "تشغيل الصوت",
  aiStopAudio: "إيقاف",
  aiCorrect: "✅ صحيح!",
  aiWrong: "❌ غير صحيح.",
  aiCorrectAnswer: "الإجابة الصحيحة: {0}",
  aiPrev: "السابق",
  aiNext: "التالي",
  aiNewQuestions: "أسئلة جديدة",
  aiEmptyTitle: "أنشئ أسئلة باستخدام الذكاء الاصطناعي",
  aiEmptyDesc: "اختر جزءًا وصعوبة، ثم اضغط على \"إنشاء أسئلة\".",
  aiLoadingMain: "الذكاء الاصطناعي يُنشئ ويُدقِّق الأسئلة...",
  aiLoadingSub: "يستغرق حوالي 10-20 ثانية",
  statsTotalQuizzes: "إجمالي الاختبارات",
  statsTotalQuestions: "إجمالي الأسئلة",
  statsAccuracy: "الدقة",
  statsWrongSummary: "ملخص الإجابات الخاطئة",
  statsViewAll: "عرض الإجابات الخاطئة",
  statsReviewed: "تمت المراجعة",
  statsPending: "بانتظار المراجعة",
  statsTopicAccuracy: "الدقة حسب موضوع القواعد",
  statsAttempts: "{0} محاولات",
  statsEmpty: "لا توجد سجلات دراسة حتى الآن. جرّب اختبار قواعد!",
  statsStartGrammar: "بدء دراسة القواعد",
  testLCTitle: "اختبار TOEFL Listening تجريبي مجاني — محادثات ومحاضرات | 2026",
  testLCDesc: "اختبار TOEFL Listening محدث لعام 2026 ومجاني. 20 سؤالًا من المحادثات والمحاضرات مع حفظ الإجابات الخاطئة تلقائيًا.",
  testRCTitle: "اختبار TOEFL Reading تجريبي مجاني — قراءة المقاطع الأكاديمية | 2026",
  testRCDesc: "اختبار TOEFL Reading محدث لعام 2026 ومجاني. 28 سؤالًا من مقاطع أكاديمية مع شرح بالذكاء الاصطناعي وملاحظات على الأخطاء.",
  reviewTitle: "مراجعة اليوم",
  reviewDesc: "نظام مراجعة ذكي قائم على منحنى النسيان الخاص بـ إبنجهاوس",
  reviewSubtitle: "راجع في الأوقات المثلى وفقاً لمنحنى النسيان",
  reviewRemaining: "المراجعات المتبقية",
  reviewProgress: "تقدم المراجعة",
  reviewCompleted: "🎉 اكتملت مراجعة اليوم!",
  reviewCompletedDesc: "تمت مراجعة {0} سؤال",
  reviewEmpty: "لا توجد عناصر للمراجعة اليوم",
  reviewEmptyDesc: "إما أنك أكملت جميع المراجعات أو لا توجد إجابات خاطئة بعد.",
  reviewStage: "المرحلة {0}",
  reviewNextInterval: "فاصل {0} يوم",
  reviewCorrect: "صحيح! انتقل إلى المرحلة التالية.",
  reviewWrong: "غير صحيح. إعادة البدء من المرحلة 1.",
  reviewNextReview: "المراجعة التالية: في {0} أيام",
  reviewResetMsg: "غير صحيح — ستراجع مرة أخرى خلال يوم واحد.",
  reviewNext: "السؤال التالي",
  reviewFinish: "إنهاء",
  reviewHowItWorks: "طريقة مراجعة إيبنجهاوس",
  reviewDaysLater: "بعد {0} أيام",
  reviewExplanation: "تتم مراجعة العناصر غير الصحيحة على فترات 1 ← 3 ← 7 ← 14 ← 30 ← 60 يومًا. الإجابات الصحيحة تنتقل إلى المرحلة التالية؛ الإجابات غير الصحيحة تعود إلى المرحلة 1.",
  notifTitle: "الإشعارات",
  notifEmpty: "لا توجد إشعارات جديدة",
  notifMarkAllRead: "تحديد الكل كمقروء",
  timeJustNow: "الآن",
  timeMinutes: "قبل {0} دقائق",
  timeHours: "قبل {0} ساعات",
  timeDays: "قبل {0} أيام",
  scoreCardEstimated: "الدرجة المقدرة",
  scoreCardCorrect: "صحيح",
  scoreCardIncorrect: "غير صحيح",
  scoreCardAccuracy: "الدقة",
  pushTitle: "احصل على إشعارات الدراسة",
  pushDesc: "سنقوم بإعلامك حول أوقات المراجعة، والمجموعات المتتالية، وأكثر من ذلك.",
  pushEnable: "تمكين الإشعارات",
  navReview: "مراجعة",
  navStats: "الإحصائيات",
  navSubscription: "الاشتراك",
  roundDetailHeading: "اختبار TOEFL التجريبي الكامل",
  roundDetailOtherRounds: "عرض جولات أخرى",
  roundSuffix: "جولة",
  footer7DayPlan: "خطة دراسة لمدة 7 أيام",
  footerTrapPatterns: "أنماط الخداع",
  aiQuizTitle: "🤖 أسئلة تدريب مخصصة بالذكاء الاصطناعي",
  aiQuizDesc: "أسئلة قواعد TOEFL التي تم إنشاؤها بواسطة الذكاء الاصطناعي",
  aiQuizGenerateDesc: "يُنشئ الذكاء الاصطناعي 5 أسئلة قواعد بنمط TOEFL في الوقت الفعلي.",
  aiQuizGenerate: "إنشاء أسئلة بالذكاء الاصطناعي",
  aiQuizGenerating: "🤖 الذكاء الاصطناعي يُنشئ الأسئلة...",
  aiQuizGeneratingTime: "يستغرق حوالي 5-10 ثوانٍ",
  aiQuizNew: "أسئلة جديدة",
  aiQuizStats: "الإحصائيات التراكمية:",
  aiQuizTimes: "مرات",
  aiQuizCheckAnswers: "التحقق من الإجابات",
  aiQuizPerfect: "🎉 ممتاز!",
  aiQuizCorrectCount: "صحيح",
  aiQuizSaving: "جاري حفظ النتائج...",
  aiQuizTryNew: "جرب أسئلة جديدة",
  aiQuizError: "فشل إنشاء أسئلة الذكاء الاصطناعي. يرجى المحاولة مرة أخرى.",
  tipsDetailStrategy: "استراتيجية مفصلة",
  subLoginRequired: "الرجاء تسجيل الدخول.",
  grammarHome: "الرئيسية",
  grammarExamples: "جمل أمثلة",
  grammarTestKnowledge: "📝 اختبار المهارة",
  grammarTestKnowledgeDesc: "جرّب أسئلة حقيقية تتعلّق بالقواعد التي تعلّمتها للتو!",
  grammarCheckAnswers: "تحقق من الإجابات",
  grammarPerfect: "🎉 ممتاز!",
  grammarCorrectCount: "صحيح",
  grammarMockCTA: "🔥 تحقق من مهاراتك من خلال اختبار تجريبي كامل!",
  grammarMockCTADesc: "اختبار RC تجريبي كامل من 100 سؤال + ملاحظات تلقائية على الإجابات الخاطئة",
  grammarStartRCMock: "ابدأ اختبار RC التجريبي",
  grammarPractice5: "التدرب على القراءة",
  grammarTestInPractice: "تحقق من ذلك في التدريب!",
  grammarTestInPracticeDesc: "اكتشف كيف تظهر النقاط النحوية في اختبارات التوفل الحقيقية.",
  grammarRelated: "📚 قواعد ذات صلة",
  wrongAnswersGrammarAI: "القواعد بالذكاء الاصطناعي",
  streakDays: "أيام",
  streakLabel: "سلسلة الدراسة",
  streak7: "سلسلة متواصلة لمدة 7 أيام!",
  streak14: "سلسلة متواصلة لمدة أسبوعين!",
  streak30: "مدهش! سلسلة متواصلة لمدة 30 يومًا!",
  reviewItems: "عناصر",
  reviewTodayLabel: "أسئلة مراجعة اليوم",
  reviewGoLabel: "📚 ابدأ المراجعة ←",
  loadingQuestions: "جارٍ تحميل الأسئلة...",
  tipsCoreTips: "نصائح أساسية",
  tipsStrategy: "الاستراتيجية",
  tipsCTA: "طبّق هذه الاستراتيجيات عمليًا!",
  testScrollHint: "مرّر لعرض السؤال والخيارات",
  testPart1Label: "القراءة الأكاديمية",
  testPart2Title: "المحادثات",
  testPart2Desc: "استمع إلى الصوت واختر الإجابة الصحيحة",
  testPart3Label: "المحاضرات",
  creditBuyBtn: "شراء الرصيد",
  creditBuyTitle: "شراء أرصدة الذكاء الاصطناعي",
  creditBuyDesc: "اشترِ أرصدة إضافية لملاحظات الذكاء الاصطناعي على التحدث/الكتابة وتدريب الذكاء الاصطناعي.",
  creditBuyError: "فشل بدء عملية الدفع",
  creditBuyNote: "الدفع عبر PayPal. تضاف الأرصدة فور اكتمال الدفع.",
  creditUnit: "رصيد",
  vocabFlashcardStart: 'بدء البطاقات',
  vocabFlashcardStop: 'إيقاف البطاقات',
  vocabFlashcardEmpty: 'أضف كلمات أولاً لبدء البطاقات.',
  vocabFlashcardSpeed: 'السرعة',
  vocabFlashcardSpeedSlow: 'بطيء',
  vocabFlashcardSpeedNormal: 'عادي',
  vocabFlashcardSpeedFast: 'سريع',
  vocabFlashcardShuffle: 'خلط',
  vocabFlashcardPrev: 'السابق',
  vocabFlashcardNext: 'التالي',
  vocabFlashcardFlip: 'قلب',
  vocabFlashcardProgress: '{current} / {total}',
};

export default ar;
